var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAdd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99919 14.6667C4.31729 14.6667 1.33252 11.6819 1.33252 7.99999C1.33252 4.31809 4.31729 1.33332 7.99919 1.33332C11.6811 1.33332 14.6659 4.31809 14.6659 7.99999C14.6618 11.6802 11.6794 14.6626 7.99919 14.6667ZM2.66585 8.11465C2.6974 11.0488 5.09326 13.4064 8.02754 13.3907C10.9618 13.3748 13.3322 10.9917 13.3322 8.05732C13.3322 5.12299 10.9618 2.73984 8.02754 2.72399C5.09326 2.70829 2.6974 5.06583 2.66585 7.99999V8.11465ZM8.66585 11.3333H7.33252V8.66665H4.66585V7.33332H7.33252V4.66665H8.66585V7.33332H11.3325V8.66665H8.66585V11.3333Z",
    fill: "#2E3A59"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.a7cf27d3a1721275ab5d83cad981bcb3.svg";
export { ForwardRef as ReactComponent };